<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Delete ODBUS Account</title>

    <link
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
      rel="stylesheet"
    />
  </head>

  <body>
    <section class="hero">
      <div class="container text-center">
        <h1>We're Sorry to See You Go</h1>

        <p class="lead mt-3">
          If you wish to permanently delete your ODBUS account, please follow
          the instructions below or contact our support team for assistance.
        </p>

        <span class="badge-custom"> Delete Account </span>
      </div>
    </section>

    <div class="container my-5">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="content-card">
            <h2>Delete Your Account</h2>

            <p>We are sorry to see you go!</p>

            <p>
              Please write to us on
              <strong>
                <a href="mailto:support@odbus.in">support@odbus.in</a>
              </strong>
              for further instructions on how to delete your account.
            </p>

            <div class="contact-box">
              <h5>Need Assistance?</h5>

              <p class="mb-4">
                Having trouble?
                <a href="mailto:support@odbus.in"> Contact us </a>
              </p>

              <a
                href="mailto:support@odbus.in?subject=Account Deletion Request"
                class="btn btn-danger me-2"
              >
                Request Account Deletion
              </a>

              <a routerLink="/" class="btn btn-primary">
                Continue to Homepage
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="text-center">
      © {{ currentYear }} ODBUS. All Rights Reserved.
    </footer>

    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js"></script>
  </body>
</html>
